import promiseIdle from './lib/promise-idle';
import ready from './lib/ready';
import ToggleArea from './lib/ToggleArea';
import {SizeTransitionBehavior} from './lib/ToggleArea_SizeBehavior';
import {ButtonBehavior} from './lib/ToggleArea_ButtonBehavior';
import nodeFromTemplate from './lib/node-from-template';
import {mutate} from './lib/promise-fastdom';

ready().then(promiseIdle()).then(function () {
    const picto = nodeFromTemplate('submenu-toggle-tpl').querySelector('svg');
    document.querySelectorAll('.mapiece-faq-item').forEach(item => {
        return Promise.resolve().then(mutate(() => {
            const title = item.querySelector('.mapiece-faq-item__title');
            title.insertAdjacentElement('beforeend', picto.cloneNode(true));
            const contents = item.querySelector('.mapiece-faq-item__contents');
            contents.hidden = true;
            new ToggleArea(contents, 'faq-item', [
                new ButtonBehavior(title, {
                    closeOnLinkClick: false,
                    closeOnOutsideClick: false,
                    focusAreaOnOpen: true,
                    jail: false,
                }),
                new SizeTransitionBehavior(['height']),
            ]);
        }));
    });
});
